import React from "react";
import { Link } from "react-router-dom";

function Card({ to, title, desc }: { to: string; title: string; desc: string }) {
  return (
    <Link
      to={to}
      className="block bg-surface/80 border border-border-subtle rounded-card p-5 interactive-card hover:border-accent focus-visible:outline-none focus-visible:shadow-focus"
    >
      <h3 className="font-mono text-sm text-primary">{title}</h3>
      <p className="text-xs text-text-muted mt-2 leading-relaxed">{desc}</p>
    </Link>
  );
}

export default function HomeCallouts() {
  return (
    <div aria-label="Quick links" className="mt-12">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card to="/projects" title="Featured Project" desc="Trend Oracle — trend analysis and predictions." />
        <Card to="/about" title="About Me" desc="Security-first workflows, automation, and build process." />
        <Card to="/articles" title="Latest Article" desc="Technical notes, post-mortems, and field reports." />
        <Card to="/contact" title="Contact" desc="Start a thread or send a direct email." />
      </div>
    </div>
  );
}

